import { Directive, input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { HasValuePipe } from '../../pipes/hasvalue.pipe';

@Directive({
    selector: 'form[xOfManyRequired]',
    providers: [{ provide: NG_VALIDATORS, useExisting: XOfManyRequiredValidatorDirective, multi: true }],
    standalone: true
})

export class XOfManyRequiredValidatorDirective implements Validator {
    readonly xOfManyRequired = input<boolean>(true);
    readonly xOfManyRequiredControls = input<AbstractControl[]>(undefined);
    readonly xOfManyRequiredAmount = input<number>(1);
    hasValuePipe: HasValuePipe = new HasValuePipe();

    validate(control: AbstractControl): ValidationErrors | null {

        const xOfManyRequiredControls = this.xOfManyRequiredControls();
        if (!xOfManyRequiredControls || !this.xOfManyRequired()) {
            return null;
        }

        const existingValue = xOfManyRequiredControls.filter(reqControl => this.hasValuePipe.transform(reqControl.value));

        const validationVal = existingValue.length >= this.xOfManyRequiredAmount()
            ? null
            : { "xofmanyrequired": `The minimum number of selections have not been made` };

        return validationVal;
    }
}